import { Injectable } from '@angular/core';
import { Md5 } from 'ts-md5';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resolve } from 'path';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class OrangeOssService {
  // 导入ali-oss
  OSS = require('ali-oss');
  // oss配置信息
  ossConfig;
  // 创建客户端
  client;
  img = new Image();
  video = document.createElement('video');
  file_md5;
  nowFile: File;

  // 配置oss&&创建客户端
  initOss(config_data: any): void {
    // oss配置信息
    this.ossConfig = {
      region: config_data.meta.region,
      // 阿里云账号AccessKey拥有所有API的访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式访问API。
      accessKeyId: config_data.data.AccessKeyId,
      accessKeySecret: config_data.data.AccessKeySecret,
      stsToken: config_data.data.SecurityToken,
      bucket: config_data.meta.bucket,
    };
    // 创建客户端
    this.client = this.OSS(this.ossConfig);
  }

  // 获取oss_token信息
  getOssToken(): Observable<any> {
    const url = 'api/material-centre/oss-sts-token';
    return this.http.get(url);
  }

  //
  checkPostfix(name: string): boolean {
    const array = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
    if (array.indexOf(name) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  //
  async fileUpload(file: File, types: number): Promise<any> {
    return new Promise((resolve1, reject) => {
      if (file.size > 1572864 || !this.checkPostfix(file.type.substring(file.type.lastIndexOf('/') + 1, file.type.length))) {
        const data = {
          status: 0,
        };
        resolve1(data);
        this.nzMessageService.create('error', '文件太大或文件格式不支持');
      } else {
        this.nowFile = file;
        this.verifyOnly(file).then((verify_only) => {
          if (verify_only.status == 1 && verify_only.data.is_cant_do == null) {
            if (verify_only.data.file_exists == null) {
              this.put(file).then((put_response) => {
                console.log(put_response);
                if (put_response.res.statusCode == 200) {
                  this.returnFile(put_response.url, put_response.name, types).then((value) => {
                    this.uploadImage(value).subscribe((value1) => {
                      if (value1.status == 1) {
                        this.nzMessageService.create('success', '上传文件成功');
                        resolve1(value);
                      } else {
                        resolve1(value);
                        this.nzMessageService.create('error', '未知错误');
                      }
                    });
                  });
                } else {
                  const data = {
                    status: 0,
                  };
                  resolve1(data);
                }
              });
            } else {
              this.returnFile(verify_only.data.file_exists.store_url, verify_only.data.file_exists.name, types).then((value) => {
                this.uploadImage(value).subscribe((value1) => {
                  if (value1.status == 1) {
                    this.nzMessageService.create('success', '上传文件成功');
                    resolve1(value);
                  } else {
                    resolve1(value);
                    this.nzMessageService.create('error', '未知错误');
                  }
                });
              });
            }
          } else {
            this.nzMessageService.create('warning', '文件已经存在');
            const data = verify_only.data.is_cant_do;
            resolve1(data);
          }
        });
      }
    });
  }

  uploadImage(value: any): Observable<any> {
    return this.http.post('api/material-centre/site/orange/upload-image', {
      store_url: value.url,
      name: value.name,
      md5: value.md5,
      ext: this.nowFile.type.substring(this.nowFile.type.lastIndexOf('/') + 1, this.nowFile.type.length),
      mime: this.nowFile.type,
      size: this.nowFile.size,
      width: value.width,
      height: value.height,
      tag: '',
    });
  }

  // 接受文件参数及文件类型返回
  async returnFile(urls: string, names: string, types: number): Promise<any> {
    return new Promise((resolve1) => {
      if (types == 1) {
        this.img.src = urls;
        this.img.onload = () => {
          const now_width = 370;
          let data;
          data = {
            name: names,
            url: urls,
            width: this.img.width,
            height: this.img.height,
            type: types,
            md5: this.file_md5,
            status: 1,
          };
          // console.log(this.img.width, this.img.height);
          resolve1(data);
        };
      } else {
        this.video.preload = 'metadata';
        this.video.src = urls;
        this.video.onloadedmetadata = () => {
          console.log(this.video.videoWidth);
          const data = {
            name: names,
            url: urls,
            width: this.video.videoWidth,
            height: this.video.videoHeight,
            type: types,
            md5: this.file_md5,
            status: 1,
          };
          // console.log(this.img.width, this.img.height);
          resolve1(data);
        };
      }
    });
  }

  // Verify the only 接受file参数，md5加密文件，验证文件是否存在
  async verifyOnly(file: File): Promise<any> {
    return new Promise((resolve1) => {
      const reader = new FileReader();
      reader.readAsBinaryString(file);
      console.log(file);
      reader.onload = () => {
        if (reader.result) {
          // console.log(reader.result);
          if (typeof reader.result === 'string') {
            console.log('Md5.hashAsciiStr', Md5.hashAsciiStr(reader.result));
            this.file_md5 = Md5.hashAsciiStr(reader.result) as string;
            const url = 'api/material-centre/site/orange/check-file-md5';
            const param = {
              md5: Md5.hashAsciiStr(reader.result) as string,
            };
            this.http
              .get(url, {
                params: param,
              })
              .subscribe((value) => {
                console.log('验证md5--------', value);
                resolve1(value);
              });
          }
        }
      };
    });
  }

  // 接受file参数，上传至阿里云oss
  async put(file: File): Promise<any> {
    return new Promise((resolve1, reject) => {
      try {
        this.getOssToken().subscribe((value) => {
          // console.log('oss_token---------------', value);
          this.initOss(value);
          const dir = 'image';
          // object表示上传到OSS的文件名称。
          const newName =
            new Date().getFullYear() +
            '/' +
            (new Date().getMonth() + 1) +
            '/' +
            new Date().getDate() +
            '/' +
            this.file_md5 +
            '-' +
            this.getFileType(file.name);
          console.log(newName);
          // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
          const r1 = this.client.put(newName, file);
          // console.log('put success: %j', r1);
          const r2 = this.client.get(file.name);
          // console.log('get success: %j', r2);
          resolve1(r1);
        });
      } catch (e) {
        this.nzMessageService.create('error', '上传文件失败');
        console.error('error: %j', e);
        return e;
      }
    });
  }

  getFileType(filePath: string): string {
    const startIndex = filePath.lastIndexOf('.');
    if (startIndex != -1) {
      return filePath.substring(startIndex + 1, filePath.length).toLowerCase();
    } else {
      return '';
    }
  }

  // 接受文件名参数，获取预览url,expires设置URL的有效时长为3600s为例，若不设置有效时长，则默认为1800s
  async getUrl(fileName: string): Promise<any> {
    let url;
    url = this.client.signatureUrl('fileName', { expires: 3600 });
    return url;
  }

  constructor(private notification: NzNotificationService, private nzMessageService: NzMessageService, private http: HttpClient) {}
}
